import type { ReactNode } from 'react'
import { useTranslation } from '../hooks/useTranslation'
import type { Cart } from '../types/display'
import CartFooter from './CartFooter'
import CartList from './CartList'

export default function OrderPanel({
  cart,
  currency,
  children,
}: {
  cart: Cart | null
  currency: string
  children?: ReactNode
}) {
  const { t } = useTranslation()

  return (
    <div className="relative flex h-full flex-1 flex-col bg-panel">
      <div className="flex items-center border-b border-divider px-[clamp(20px,3vw,36px)] pb-[clamp(10px,1.8vh,20px)] pt-[clamp(14px,2.5vh,26px)]">
        <div className="text-[clamp(0.65rem,1.3vh,1rem)] font-medium uppercase tracking-[0.2em] text-text-mid">
          {t('your-order')}
        </div>
      </div>

      <CartList items={cart?.items ?? []} currency={currency} />
      <CartFooter cart={cart ?? {}} currency={currency} />
      {children}
    </div>
  )
}
